import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let EssentialsDialog = {
    selector: "vcEssentialsDialog",
    templateUrl: "/angular/components/profile/essentials-dialog.component.html",
    bindings: {
        country: "=",
        helpScreen: "=",
    },
    controller: class EssentialsDialogController {
        // * bindings for typescript compiler *
        public country: any;
        public helpScreen: any;
        // ************************************

        public __env: any;
        private dialog: DialogUtils;

        constructor(__env: any, DialogUtils: DialogUtils) {
            this.__env = __env;
            this.dialog = DialogUtils;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        confirm(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("profile")
    .component(EssentialsDialog.selector, EssentialsDialog);
